import { useStore } from './store';
import { useToast } from './components/ui/Toast';

export const SubmitButton = () => {
    const nodes = useStore((state) => state.nodes);
    const edges = useStore((state) => state.edges);
    const { toast } = useToast();

    const handleSubmit = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/pipelines/parse`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ nodes, edges }),
            });

            const data = await response.json();

            toast.info(`Number of Nodes: ${data.num_nodes}\nNumber of Edges: ${data.num_edges}\nIs DAG: ${data.is_dag}`, {
                title: 'Pipeline Analysis',
                duration: 6000
            });
        } catch (error) {
            console.error("Error submitting pipeline:", error);
            toast.error('Failed to submit pipeline. Check console for details.', { title: 'Submission Failed' });
        }
    }

    return (
        <button
            type="submit"
            className="px-4 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 active:bg-emerald-800 transition-colors font-orbitron tracking-wider text-sm shadow-[0_0_10px_rgba(16,185,129,0.4)] flex items-center gap-2"
            onClick={handleSubmit}
        >
            Run Pipeline
        </button>
    );
}

